import type { ReactNode } from "react"

export function MainCard({ children }: { children: ReactNode }) {
  return (
    <div className="theme-form h-min w-full rounded-2xl bg-white p-5 shadow-sm sm:p-6 lg:col-span-2 lg:p-8">
      {children}
    </div>
  )
}

export function InfoCard({ children }: { children: ReactNode }) {
  return (
    <div className="theme-form h-min w-full rounded-2xl bg-white p-5 shadow-sm sm:p-6 lg:col-span-1 lg:p-8">
      {children}
    </div>
  )
}
